import { mapActions, mapGetters } from 'vuex';
import SummaryView from '@/helpers/summaryView';

export default {
	computed: {
		...mapGetters(['getCalculation']),
		...mapGetters('contracting', ['getSelectedOffer', 'getAllFormData']),
	},
	methods: {
		...mapActions('contracting', ['saveNew']),
		beforeNext() {
			return new Promise(async (resolve, reject) => {
				if (!this.getCheckboxData('differentInsuredMailingAddress')) {
					_.each(this.fields.mailingAddress, field => {
						this.setFormData({
							parent: field.input.parent,
							group: field.input.group,
							prop: field.input.prop,
							value: this.getFormData({
								parent: field.input.parent,
								group: 'permanentAddress',
								prop: field.input.prop,
							}),
						});
					});
				}

                if (!this.getCheckboxData('differentInsuredPermanentAddress')) {
                    _.each(this.fields.permanentAddress, field => {
                        this.setFormData({
                            parent: field.input.parent,
                            group: field.input.group,
                            prop: field.input.prop,
                            value: this.getFormData({
                                parent: 'baseData',
                                group: 'riskBearingAddress',
                                prop: field.input.prop,
                            }),
                        });
                    });
                }

                if(typeof this.beforePrevAfter !== "undefined") {
                    this.beforePrevAfter();
                }

				const summaryView = new SummaryView(
					this.getCalculation,
					this.getSelectedOffer,
					this.getAllFormData,
					this.$store,
				);

				const saved = await this.saveNew({ dataKey: 'insuredData', summaryView: summaryView.getData() });

				if (saved) {
					if (this.getCalculation.real_estate.mortgage) {
						resolve({ success: true, routeTo: 'contracting-financing' });
					}

					resolve({ success: true, routeTo: 'contracting-summary' });
				}
			});
		},
		beforePrev() {
			return new Promise((resolve, reject) => {
				resolve({ success: true, routeTo: 'contracting-base' });
			});
		},
	},
};
